<ng-container *ngIf="isButton">
  <div class="row box {{boxClasses}}">
    <div class="p-0 min-height-90px " *ngFor="let opt of btnList"
      [ngClass]="{'box-item': selectedOption !== opt.value}">
      <button type="button" [id]="radioGroupButtonId ? radioGroupButtonId+'-'+(opt.title.replaceAll(' ','-')).toLowerCase() : (opt.title.replaceAll(' ','-')).toLowerCase()"
              class="btn btn-lg btn-block btn-white bg-white rounded-0 h-100 w-100"
              [class.selected]="selectedOption == opt.value" (click)="selectedOption = opt.value; onSelection()"
              [disabled]="disabled">
        <div *ngIf="opt.title">
          <small class="font-weight-bold">{{opt.title}}</small>
        </div>
        <div *ngIf="opt.text" class="color-secondary-gray font-size-12 font-weight-normal">{{opt.text}}</div>
      </button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!isButton">
  <div class="btn-group" btnRadioGroup>
    <button [id]="radioGroupButtonId ? radioGroupButtonId+'-'+(opt.title.replaceAll(' ','-')).toLowerCase() : (opt.title.replaceAll(' ','-')).toLowerCase()"
            class="btn btn-white bg-white rounded-0 item" *ngFor="let opt of btnList"
            (click)="selectedOption = opt.value; onSelection()"
            [class.selected]="selectedOption == opt.value" [disabled]="disabled">
      <div *ngIf="opt.title">
        <small class="font-weight-bold">{{opt.title}}</small>
      </div>
      <small *ngIf="opt.text" class="text-muted">{{opt.text}}</small>
    </button>
  </div>
</ng-container>
